function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordShow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "48pt",
    height: "48pt",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(69.803922%,69.803922%,83.137255%)",
      fillOpacity: 1
    },
    d: "M 46.195312 22.863281 C 39.109375 13.550781 31.589844 8.828125 23.835938 8.828125 C 10.652344 8.828125 2.050781 22.453125 1.6875 23.03125 C 1.21875 23.789062 1.269531 24.761719 1.816406 25.46875 C 8.875 34.566406 16.382812 39.179688 24.128906 39.179688 C 36.914062 39.179688 46.628906 25.902344 46.628906 24.15625 C 46.628906 23.691406 46.476562 23.234375 46.195312 22.863281 Z M 24.128906 34.902344 C 18.105469 34.902344 12.066406 31.257812 6.167969 24.070312 C 8.445312 20.984375 15.117188 13.101562 23.835938 13.101562 C 29.855469 13.101562 35.902344 16.839844 41.824219 24.21875 C 39.539062 27.238281 32.871094 34.902344 24.128906 34.902344 Z M 24.128906 34.902344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(69.803922%,69.803922%,83.137255%)",
      fillOpacity: 1
    },
    d: "M 24.003906 15.488281 C 19.308594 15.488281 15.484375 19.308594 15.484375 24.003906 C 15.484375 28.699219 19.304688 32.519531 24.003906 32.519531 C 28.699219 32.519531 32.519531 28.699219 32.519531 24.003906 C 32.519531 19.308594 28.699219 15.488281 24.003906 15.488281 Z M 24.003906 28.242188 C 21.664062 28.242188 19.761719 26.339844 19.761719 24.003906 C 19.761719 21.664062 21.664062 19.761719 24.003906 19.761719 C 26.34375 19.761719 28.242188 21.664062 28.242188 24.003906 C 28.246094 26.339844 26.34375 28.242188 24.003906 28.242188 Z M 24.003906 28.242188 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordShow);
export default __webpack_public_path__ + "static/media/password_show.0177921842cdd07f71b5f86131ea9938.svg";
export { ForwardRef as ReactComponent };